var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition-group",
    {
      attrs: {
        name: "custom-classes-transition",
        "enter-active-class": "animated slideInLeft",
        "leave-active-class": "animated slideOutLeft",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.toggleSideMenu,
              expression: "toggleSideMenu",
            },
          ],
          key: "tile-parent",
          staticClass: "m-3",
          style: { "min-width": _vm.inlineStyle },
        },
        [
          _c(
            "article",
            {
              key: "tile-child",
              staticClass: "box is-flex",
              style: { "min-width": _vm.inlineStyle },
            },
            [
              _c(
                "div",
                { staticClass: "is-flex-grow-1" },
                [_vm._t("side-menu")],
                2
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }